import { FC, useMemo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import {
  NOTIFICATION_DEFAULT_ERROR_MESSAGE,
  NotificationColors,
  useNotificationContext,
} from 'application/providers/NotificationProvider';
import styles from './index.module.scss';

import { TEXTS } from '../../texts';
import { useSelectPointsGroupPointsViewModel } from './useSelectPointsGroupPointsViewModel';
import PointGroupPointsList from '../PointsGroupsPointsList';

const SelectPointsGroupPointsModal: FC<ModalProps[ModalTypes.SELECT_POINTS_GROUP_POINTS]> = ({
  devicesGroupId,
  close,
}) => {
  const {
    allPointList,
    loadMore,
    selectedPoints,
    onPointsChange,
    isButtonDisabled,
    updatePointsGroup,
    isButtonLoading,
  } = useSelectPointsGroupPointsViewModel({ devicesGroupId });

  const { isIpad } = useMedia();

  const notification = useNotificationContext();

  const handleSaveClick = async () => {
    close();
    try {
      await updatePointsGroup();
    } catch (error: any) {
      notification.showNotification({
        type: NotificationColors.ERROR,
        children: error?.message ? error.message : NOTIFICATION_DEFAULT_ERROR_MESSAGE,
      });
    }
  };

  const actionButtons = useMemo(
    () => [
      <Button
        key="button_bind_video_stream_modal"
        elementId="button_bind_video_stream_modal"
        type={ButtonType.PRIMARY}
        isLoading={isButtonLoading}
        onClick={handleSaveClick}
        isDisabled={isButtonDisabled}>
        {TEXTS.MODAL_SELECT_POINTS_BUTTON_SUBMIT_TEXT}
      </Button>,
    ],
    [isButtonLoading, isButtonDisabled, handleSaveClick]
  );

  return (
    <ModalScreen
      title={TEXTS.MODAL_SELECT_POINTS_TITLE}
      titlePlacement="left"
      disableScroll={!isIpad}
      contentClassName={styles.VideoStreamBindModalContent}
      onClose={close}
      actionButtons={actionButtons}>
      <PointGroupPointsList
        points={allPointList.points || []}
        isLoading={allPointList.isReloading}
        loadMore={loadMore}
        onChange={onPointsChange}
        deviceGroupId={devicesGroupId}
        selectedPoints={selectedPoints}
      />
    </ModalScreen>
  );
};

export default SelectPointsGroupPointsModal;
